import { Stack } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { Button } from "../../../../../components/ButtonNew";

export const ActionButtons = ({
  isNextButtonDisabled,
  isSaveButtonDisabled,
  nextButtonText,
  onBack,
  onNext,
  onSaveAndExit,
  showBackButton,
  showSaveAndExit,
}: {
  isNextButtonDisabled: boolean;
  isSaveButtonDisabled: boolean;
  nextButtonText: string;
  onBack: () => void;
  onNext: () => void;
  onSaveAndExit: () => void;
  showBackButton: boolean;
  showSaveAndExit: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <div className="mt-8 border-t bg-lds-surface-bright border-ds-subtle">
      <Stack className="mx-auto h-22 justify-between px-14">
        {showBackButton ? (
          <Button onClick={onBack} size="sm" variant="secondary">
            {t("general.back")}
          </Button>
        ) : (
          <span />
        )}
        <Stack className="items-center gap-4">
          {showSaveAndExit && (
            <Button disabled={isSaveButtonDisabled} onClick={onSaveAndExit} size="sm" variant="tertiary">
              {t("general.saveAndExit")}
            </Button>
          )}
          <Button disabled={isNextButtonDisabled} onClick={onNext} size="sm" variant="primary">
            {nextButtonText}
          </Button>
        </Stack>
      </Stack>
    </div>
  );
};
